import React, {
    memo,
    useCallback,
    Fragment,
    useContext,
    useState,
    useEffect,
    Suspense
} from "react";

//Context
import { AuthContext } from "../../middlewares/Auth";
import { AbilityContext } from "../../config/Can";

//Librerias
import { Link, Outlet, useNavigate } from "react-router-dom";
import defineRulesFor from "../../config/Permissions";
import Loader from "../../components/Loader";
//Componentes Material-UI
import {
    Toolbar,
    Menu,
    MenuItem,
    Avatar,
    IconButton,
    Hidden,
    Typography,
    Box,
    Container,
    CssBaseline
} from "@mui/material";

import MuiAppBar from "@mui/material/AppBar"

//Iconos Material-UI
import { Menu as MenuIcon } from "@mui/icons-material";

//Style Material-UI
import { createStyles, styled } from "@mui/material/styles";

//Mis componentes
import MenuDrawer from "./Menu";
//import ChatBot from "../../components/Chatbot";

//Estilos de mi componente
const MenuStyle = createStyles(() => ({
    avatarInterno: {
        width: "90px",
        height: "90px",
    },
    avatar: {
        width: "30px",
        height: "30px",
    },
}));

const drawerWidth = 240;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        flexGrow: 1,
        width: "80vh",
        padding: theme.spacing(1),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        ...(open && {
            [theme.breakpoints.up("sm")]: {
                transition: theme.transitions.create('margin', {
                    easing: theme.transitions.easing.easeOut,
                    duration: theme.transitions.duration.enteringScreen,
                }),
                marginLeft: 0,
            },
        }),
    }),
);

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        [theme.breakpoints.up("sm")]: {
            width: `calc(100% - ${drawerWidth}px)`,
            marginLeft: `${drawerWidth}px`,
            transition: theme.transitions.create(['margin', 'width'], {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },

    }),
}));

/**
* Componente con el cual se renderiza el menu de navegación de mi aplicativo donde se controla los permisos
* @type {Function} menu de mi aplicativo
* @param {children} children recibe el hijo para poder renderizar
* @returns retorna el container donde se renderizaran los diferentes componentes de mi aplicativo
*/

const ContainerMenu = ({ children }) => {
    //===============================================================================================================================================
    //========================================== Context ============================================================================================
    //===============================================================================================================================================
    const { strInfoUser, cerrarSesion } = useContext(AuthContext);
    const ability = useContext(AbilityContext);
    //===============================================================================================================================================
    //========================================== States =============================================================================================
    //===============================================================================================================================================
    const [openMenu, setOpenMenu] = useState(false);
    const [openMenuProfile, setOpenMenuProfile] = useState(false);
    const [anchorEl, setAnchorEl] = useState();
    const [selectedList, setSelectedList] = useState(0);
    //===============================================================================================================================================
    //========================================== Hooks ==============================================================================================
    //===============================================================================================================================================
    let history = useNavigate();
    //===============================================================================================================================================
    //========================================== Funciones ============================================================================================
    //===============================================================================================================================================

    const toggleDrawer = useCallback(() => {
        setOpenMenu(!openMenu);
    }, [openMenu]);

    const toggleProfile = useCallback(() => {
        setOpenMenuProfile(!openMenuProfile);
    }, [openMenuProfile]);

    const handleProfile = useCallback((e) => {
        setAnchorEl(e.currentTarget);
    }, []);

    const cambiarInfo = useCallback(
        (url, index) => {
            history(url);
            setSelectedList(index);
        },
        [history]
    );

    useEffect(() => {
        if (strInfoUser) {
            let rules = defineRulesFor(strInfoUser?.strRolApp, "WILSON");
            ability.update(rules);
        }
    }, [strInfoUser, ability]);
    //===============================================================================================================================================
    //========================================== Renders ============================================================================================
    //===============================================================================================================================================
    const nombreUsuario = `${strInfoUser?.strNombre} ${strInfoUser?.strApellidos}`;
    const classes = MenuStyle();

    return (
        <Fragment>
            <Box sx={{ display: "flex" }}>
                <CssBaseline />
                <AppBar position="fixed" open={openMenu} >
                    <Toolbar style={{ minHeight: 45 }}>
                        <Box flexGrow={1} display="flex" alignItems="center">
                            {!openMenu ? (
                                <IconButton onClick={(e) => toggleDrawer(e, true)}>
                                    <MenuIcon sx={{ color: "#ffffff" }} />
                                </IconButton>
                            ) : null}
                            <Typography variant="h6">
                                <Link
                                    style={{
                                        textDecoration: "none",
                                        color: "white",
                                    }}
                                    to="/wilson/inicio"
                                >
                                    WILSON
                                </Link>
                            </Typography>
                        </Box>
                        <Box display="flex" justifyContent="center" alignItems="center">
                            <Hidden smDown>
                                <Typography variant="subtitle1" style={{ paddingRight: "10px" }}>
                                    {strInfoUser?.strUsuario}
                                </Typography>
                            </Hidden>
                            <IconButton
                                onClick={(e) => {
                                    toggleProfile();
                                    handleProfile(e);
                                }}
                            >
                                <Avatar sx={classes.avatar}>
                                </Avatar>
                            </IconButton>
                            <Menu
                                anchorEl={anchorEl}
                                open={openMenuProfile}
                                onClose={toggleProfile}
                            >
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                    padding="0px 15px"
                                >
                                    <Box>
                                        <Avatar sx={classes.avatarInterno}>
                                        </Avatar>
                                    </Box>
                                    <Box
                                        display="flex"
                                        flexDirection="column"
                                        justifyContent="center"
                                    >
                                        <Box padding="6px 16px" maxWidth="200px">
                                            <Typography noWrap>
                                                <b>
                                                    {strInfoUser
                                                        ? nombreUsuario
                                                        : "undefined"}
                                                </b>
                                            </Typography>
                                            <Typography variant="caption" noWrap>
                                                {strInfoUser ? strInfoUser.strEmail : undefined}
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <MenuItem onClick={toggleProfile}>
                                                <a
                                                    href="https://choucairtesting-my.sharepoint.com/person.aspx"
                                                    rel="noopener noreferrer"
                                                    style={{
                                                        textDecoration: "none",
                                                        color: "black",
                                                    }}
                                                    target="_blank"
                                                >
                                                    Mi perfil de Office 365
                                                </a>
                                            </MenuItem>
                                            <MenuItem onClick={() => cerrarSesion()}>
                                                Cerrar sesión
                                            </MenuItem>
                                        </Box>
                                    </Box>
                                </Box>
                            </Menu>
                        </Box>
                    </Toolbar>
                </AppBar>
                <MenuDrawer
                    open={openMenu}
                    drawerWidth={drawerWidth}
                    toggleDrawer={toggleDrawer}
                    cambiarInfo={cambiarInfo}
                    selectedList={selectedList}
                />
                <Main open={openMenu}>
                    <Container maxWidth="xl" sx={{ paddingTop: "35px" }}>
                        <Suspense fallback={<Loader />}>
                            <Outlet />
                        </Suspense>
                        {/* {<ChatBot />} */}
                    </Container>
                </Main>
            </Box>
        </Fragment>
    );
};

export default memo(ContainerMenu);